import React from "react";
import { Row, Col, Input, Label } from "reactstrap";
import AddonCounter from "../AddOnCounter";

const AddonsSection = ({
  addonLabels,
  selectedItem,
  setSelectedItem,
  darkMode,
  currency,
}) => {
  const handleCheckBoxChange = (e, label) => {
    const isChecked = e.target.checked;

    setSelectedItem((prev) => {
      let updatedAddons = [...prev.addons];

      if (isChecked) {
        updatedAddons.push({
          id: label.id,
          name: label.name,
          image: label.image,
          price: Number(label.price),
          quantity: 1,
        });
      } else {
        updatedAddons = updatedAddons.filter((addon) => addon.id !== label.id);
      }

      const addonsTotal = updatedAddons.reduce(
        (sum, addon) => sum + addon.price * addon.quantity,
        0
      );

      return {
        ...prev,
        addons: updatedAddons,
        totalPrice: prev.price * prev.quantity + addonsTotal,
      };
    });
  };

  const handleAddonQuantityChange = (label, newQuantity) => {
    setSelectedItem((prev) => {
      const updatedAddons = prev.addons
        .map((addon) =>
          addon.id === label.id ? { ...addon, quantity: newQuantity } : addon
        )
        .filter((addon) => addon.quantity > 0);

      const addonsTotal = updatedAddons.reduce(
        (sum, addon) => sum + addon.price * addon.quantity,
        0
      );

      return {
        ...prev,
        addons: updatedAddons,
        totalPrice: prev.price * prev.quantity + addonsTotal,
      };
    });
  };

  return (
    <div className="my-4 px-3">
      <Row className="justify-content-between align-items-center mb-2">
        <Col xs={6}>
          <h4
            className={`fs--22 mb-0 ${
              darkMode ? "normal-heading-dark" : "normal-heading"
            }`}
          >
            Select your Add-ons
          </h4>
        </Col>
        <Col xs={6} className="d-flex justify-content-end">
          <h4 className="text-danger fs--18 fw--600 mb-0">Optional</h4>
        </Col>
      </Row>

      <div className="add-ons-container px-4 py-2">
        {addonLabels?.map((label, index) => {
          const isSelected = selectedItem.addons.some(
            (item) => item.id === label.id
          );
          const selectedAddon = selectedItem.addons.find(
            (item) => item.id === label.id
          );
          const quantity = selectedAddon?.quantity || 1;

          return (
            <Row
              key={`addon-${label.id}-${index}`}
              className="py-2 border-bottom"
            >
              <Col className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <div className="custom-checkbox-wrapper">
                    <Input
                      type="checkbox"
                      id={`addon-${index}`}
                      name="addons"
                      checked={isSelected}
                      onChange={(e) => handleCheckBoxChange(e, label)}
                      className="custom-checkbox-input"
                    />
                    <span className="custom-checkbox-checkmark"></span>
                  </div>
                  <Label
                    check
                    htmlFor={`addon-${index}`}
                    className={`ml-2 text-capitalize ${
                      darkMode ? "normal-heading-dark" : "normal-heading"
                    }`}
                  >
                    {label.name}
                  </Label>
                </div>

                <div className="d-flex align-items-center">
                  {isSelected && (
                    <AddonCounter
                      quantity={quantity}
                      onChange={(newQuantity) =>
                        handleAddonQuantityChange(label, newQuantity)
                      }
                      darkMode={darkMode}
                    />
                  )}
                  <span
                    className={`ml-3 ${
                      darkMode ? "normal-heading-dark" : "normal-heading"
                    }`}
                  >
                    {label.price === 0
                      ? "Free"
                      : label.price
                      ? `${currency || "$"}${(label.price * quantity).toFixed(
                          2
                        )}`
                      : "-"}
                  </span>
                </div>
              </Col>
            </Row>
          );
        })}
      </div>
    </div>
  );
};

export default AddonsSection;
